export function breadcrumbDropdown() {
    const dropdowns = document.querySelectorAll('.breadcrumb-dropdown');

    if (!dropdowns.length) return;

    function closeAllDropdowns() {
        dropdowns.forEach((dropdown) => {
            const toggle = dropdown.querySelector('.breadcrumb-dropdown__toggle');
            const menu = dropdown.querySelector('.breadcrumb-dropdown__menu');

            if (toggle && menu) {
                toggle.setAttribute('aria-expanded', 'false');
                dropdown.classList.remove('breadcrumb-dropdown--is-open');
            }
        });
    }

    dropdowns.forEach((dropdown) => {
        const toggle = dropdown.querySelector('.breadcrumb-dropdown__toggle');
        const menu = dropdown.querySelector('.breadcrumb-dropdown__menu');

        if (!toggle || !menu) {
            console.error('Missing elements - toggle or menu not found');
            return;
        }

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            closeAllDropdowns();

            if (!isExpanded) {
                toggle.setAttribute('aria-expanded', 'true');
                dropdown.classList.add('breadcrumb-dropdown--is-open');
            }
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.breadcrumb-dropdown')) {
            closeAllDropdowns();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllDropdowns();
        }
    });
}
